/** Snap-punkter for bottom sheets (markinfo): peek / halv / fuld. */
export type SheetSnap = 'peek' | 'half' | 'full';
export const SNAP_ORDER: SheetSnap[] = ['peek', 'half', 'full'];
export const SNAP_LABEL: Record<SheetSnap, string> = {
  peek: 'lav',
  half: 'halv',
  full: 'fuld',
};

const PEEK_PX = 168;
/** Hurtigere end dette (px/ms) tæller som et fling og springer ét snap-punkt. */
const FLING_VELOCITY = 0.5;

export function snapHeights(viewportHeight: number): Record<SheetSnap, number> {
  const full = Math.round(viewportHeight * 0.86);
  return {
    peek: Math.min(PEEK_PX, full),
    half: Math.max(Math.min(PEEK_PX, full), Math.round(viewportHeight * 0.55)),
    full,
  };
}

/**
 * Finder det snap-punkt, et træk ender på.
 * `dragDeltaY` er positiv nedad (sheetet bliver lavere); `velocityY` er px/ms, positiv nedad.
 */
export function resolveSnap(
  start: SheetSnap,
  heights: Record<SheetSnap, number>,
  dragDeltaY: number,
  velocityY: number,
): SheetSnap {
  const index = SNAP_ORDER.indexOf(start);
  if (Math.abs(velocityY) >= FLING_VELOCITY && Math.abs(dragDeltaY) > 12) {
    const step = velocityY > 0 ? -1 : 1;
    return SNAP_ORDER[Math.min(SNAP_ORDER.length - 1, Math.max(0, index + step))];
  }
  const target = heights[start] - dragDeltaY;
  let best = SNAP_ORDER[0];
  for (const snap of SNAP_ORDER) {
    if (Math.abs(heights[snap] - target) < Math.abs(heights[best] - target)) best = snap;
  }
  return best;
}

/** Tastatur/klik på håndtaget: peek -> halv -> fuld -> peek. */
export function nextSnap(current: SheetSnap): SheetSnap {
  return SNAP_ORDER[(SNAP_ORDER.indexOf(current) + 1) % SNAP_ORDER.length];
}
